import { useQuery } from '@tanstack/react-query'

import {
  getCurrentProvider,
  getUserProviders,
} from '../infrastructure/api/authApi'

export const useUserProviders = () => {
  return useQuery({
    queryKey: ['user-providers'],
    queryFn: async () => {
      const result = await getUserProviders()
      if (!result.response.ok || !result.data) {
        throw new Error('Failed to load user providers')
      }
      return result.data
    },
  })
}

export const useCurrentProvider = () => {
  return useQuery({
    queryKey: ['current-provider'],
    queryFn: async () => {
      const result = await getCurrentProvider()
      if (!result.response.ok || !result.data) {
        throw new Error('Failed to load current provider')
      }
      return result.data
    },
  })
}
